<label class="section-label heading2">Summary - By Active Days</label>
<ng-container *ngIf="data$ | async as data; else empty">
  <ng-container *ngIf="totals$ | async as totals">
    <div class="table-empty-state  body1 " *ngIf="data.length == 0">
      No Orders Yet!
    </div>
    <table mdbTable #tableEl="mdbTable" *ngIf="data.length != 0">
      <thead>
        <tr>
          <th class="table_heading1">
            Day
          </th>
          <th class="table_heading1 no_mobile">
            Date
          </th>
          <th class="table_heading1">
            Units
          </th>
          <th class="table_heading1 no_mobile">
            Avg Price
          </th>
          <th class="table_heading1 no_mobile">
            Sub Total
          </th>
          <th class="table_heading1 no_mobile">
            Service Fees
          </th>
          <th class="table_heading1 no_mobile">
            Tips
          </th>
          <th class="table_heading1 no_mobile">
            Tip %
          </th>
          <th class="table_heading1">
            Total
          </th>
          <th class="table_heading1 no_mobile">
            # Redeemed
          </th>
          <th class="table_heading1">
            Redeemed
          </th>
          <th class="table_heading1 no_mobile">
            % Revenue
          </th>
        </tr>
      </thead>
      <tbody class="body1">
        <tr
          class="hoverable"
          *ngFor="
            let element of data | slice: firstIndex:lastIndex;
            let i = index
          "
        >
          <td class="no_mobile">
            {{ map.get(element.day) }}
          </td>
          <td>
            {{ element.key }}
          </td>
          <td>
            {{ element.units }}
          </td>
          <td class="no_mobile">
            {{ element.avgPrice | currency }}
          </td>
          <td class="no_mobile">
            {{ element.subtotal | currency }}
          </td>
          <td class="no_mobile">
            {{ element.fees | currency }}
          </td>
          <td class="no_mobile">{{ element.tips | currency }}</td>
          <td class="no_mobile">
            {{ element.tipPercent | percent }}
          </td>
          <td>
            {{ element.revenue | currency }}
          </td>
          <td class="no_mobile">
            {{ element.redeemedUnits }}
          </td>
          <td>
            {{ element.redeemedPercent | percent }}
          </td>
          <td class="no_mobile">
            {{ element.revenue / totals.revenue | percent }}
          </td>
        </tr>
      </tbody>
      <tfoot class="body1" *ngIf="data.length">
        <tr class="totals-row">
          <td class="left">TOTAL</td>
          <td class="no_mobile"></td>
          <td>{{ totals.units }}</td>
          <td class="no_mobile">{{ totals.avgPrice | currency }}</td>
          <td class="no_mobile">{{ totals.subtotal | currency }}</td>
          <td class="no_mobile">{{ totals.fees | currency }}</td>
          <td class="no_mobile">{{ totals.tips | currency }}</td>
          <td class="no_mobile">{{ totals.tipPercent | percent }}</td>
          <td>{{ totals.revenue | currency }}</td>
          <td class="no_mobile">{{ totals.redeemedUnits }}</td>
          <td class="right-mobile">{{ totals.redeemPercent | percent }}</td>
          <td class="right no_mobile">{{ 1 | percent }}</td>
        </tr>
      </tfoot>
    </table>
    <div class="caption" *ngIf="data.length != 0">
      *Date shown is based on event date, NOT purchase date
    </div>
  </ng-container>
  <div
    class="d-flex flex-row no-gutters  align-items-center"
    style="height:40px;padding:6px;"
    *ngIf="data.length != 0"
  >
    <div class="chip dropup" mdbDropdown>
      <div class="btn-group" mdbDropdownToggle>
        {{ showing }}
        <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
      </div>
      <div class="dropdown-menu dropdown-primary">
        <a
          class="dropdown-item"
          *ngFor="let item of itemsPerPage"
          (click)="onItemsPerPageChange(item)"
          >{{ item }}</a
        >
      </div>
    </div>
    <label>per page</label>
    <label class="ml-auto">{{
      firstIndex +
        1 +
        "-" +
        (lastIndex > data.length ? data.length : lastIndex) +
        " of " +
        data.length
    }}</label>

    <div id="pg_left" (click)="onDecrement(data.length)"></div>
    <div id="pg_right" (click)="onIncrement(data.length)"></div>
  </div>
</ng-container>
<ng-template #empty>
  <div class="table-empty-state body1 "></div>
</ng-template>
